import { useCallback, useRef } from 'react';

export default function useEventListener(props, key, callback) {
  const propRef = useRef();

  propRef.current = [callback, props[key]];
  return useCallback(
    (...initArgs) => propRef.current.reduce((args, cb) => {
      if (typeof cb === 'function') {
        const newArgs = cb(...args);
        return Array.isArray(newArgs) ? newArgs : args;
      }
      return args;
    }, initArgs),
    [],
  );
}
